<template>
  <div class="createAcct">
    <navbar></navbar>
    <svgicon icon="design-element" class="design-element"></svgicon>
    <div class="createAcct__wrap">
      <h6 class="createAcct__title signup__title">Forgot your password?</h6>
      <p class="signup__subtitle mb-5" style="font-weight: 400;">
        Enter your email address to reset your password
      </p>
      <div class="createAcct__form">
        <form class="set_admin_password_form">
          <div class="mb-5">
            <float-label class="form__input-wrap mb-2">
              <input
                type="email"
                v-model="email"
                required
                placeholder="Email"
                class="form__input"
              />
            </float-label>
            <FormError :validation-msg="validationMsg($v.email)" />
          </div>

          <button
            type="submit"
            class="createAcct__ctaBtn"
            @click.prevent="submit"
          >
            <svgicon
              v-if="loading"
              icon="spinner"
              class="button__loader"
            ></svgicon
            >Send Reset Link
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import navbar from "../navbar";
import { required, email } from "vuelidate/lib/validators";
import { validationMessage } from "vuelidate-messages";
import FormError from "../../resuables/form-error.vue";
import { forgotPassword } from "../../../../services/dashboard";

const formMessages = {
  emailRequired: () => "Email is required",
  email: () => "Must be a valid email"
};

export default {
  name: "forgot-password",
  components: {
    navbar,
    FormError
  },
  data() {
    return {
      email: "",
      loading: false,
      error: null,
      errorMessage: ""
    };
  },
  validations: () => {
    return {
      email: {
        emailRequired: required,
        email
      }
    };
  },
  methods: {
    validationMsg: validationMessage(formMessages),

    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.error = this.$v;
      } else {
        this.loading = true;

        const port = process.env.PORT || "8082";

        try {
          const body = {
            email: this.email,
            callbackUrl:
              process.env.VUE_APP_DOMAIN === "localhost"
                ? `http://${process.env.VUE_APP_DOMAIN}:${port}/change-password`
                : `https://${process.env.VUE_APP_DOMAIN}/change-password`
          };

          const response = await forgotPassword(body);
          if (response.statusCode === 201) {
            this.$notification.success({
              message: "Password Reset Sent",
              description: response.message
            });
            localStorage.setItem("resend-email", JSON.stringify(this.email));
            this.$router.push("/email-sent");
          }
        } catch (error) {
          return error;
        } finally {
          this.loading = false;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/authentication/forgot-password/forgot-password.vue